import { VariaveisAmbiente } from 'config';
import { PlanoFormModel } from 'model/app/forms/plano/plano-form-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function usePutAtualizarPlano() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putAtualizarPlano = useCallback(
        (plano: PlanoFormModel) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/Planos`,
                method: 'PUT',
                data: plano,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        putAtualizarPlano,
    };
}
